<template>
  <div class="study-task-article">
    <div class="desc">
      {{ desc }}
    </div>
    <div class="btn">
      <span @click="clickAction">查看全文 ></span>
    </div>
  </div>
</template>

<script setup>
import { defineProps, getCurrentInstance } from 'vue'
import { hostPath } from '@utils/basePath'
import { appPort, jumpModuleApp } from '@/widget'
const {
  proxy: { $router }
} = getCurrentInstance()
const props = defineProps({
  desc: {
    type: String,
    default: ''
  },
  id: {
    type: Number,
    default: 0
  },
  taskId: {
    type: Number,
    default: 0
  }
})

const clickAction = () => {
  if (appPort()) {
    jumpModuleApp({
      typeId: 'h5',
      url: `${hostPath}/learn/article/${props.id}`
    })
  } else {
    $router.push({
      path: '/article/' + props.id
    })
  }
}
</script>

<style lang="scss" scoped>
.study-task-article {
  .desc {
    color: #626366;
    font-size: 28px;
    line-height: 42px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  .btn {
    text-align: right;
    margin-top: 10px;
    span {
      color: #6183f2;
      font-size: 28px;
      line-height: 44px;
    }
  }
}
</style>
